import React from 'react';
import {
  MIN_WIDTH,
  Typography,
  useMedia,
  VStack,
} from '@vivaahealth/design-system';

interface TextDataProps {
  label: string;
  value: string;
}

const TextData: React.FC<TextDataProps> = ({ label, value }) => {
  const isDesktop = useMedia(MIN_WIDTH.MD);

  return (
    <VStack gap={4} width={'100%'} whiteSpace={'unset'}>
      <Typography variant={isDesktop ? 'paragraph-large' : 'paragraph-medium'}>
        {value}
      </Typography>
      <Typography
        variant={isDesktop ? 'title-medium' : 'title-small'}
        bold
        color="secondary"
      >
        {label}
      </Typography>
    </VStack>
  );
};

export default TextData;
